import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgMobileSkeleton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 320 318"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect rx={4} fill="#fff" />
    <path d="M0 4a4 4 0 0 1 4-4h312a4 4 0 0 1 4 4v166H0V4Z" fill="#E6E6E6" />
    <path
      d="M32.5 212c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5ZM86.5 212c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5Z"
      stroke="#E6E6E6"
    />
    <rect x={125.5} y={181.5} width={56} height={30} rx={15} stroke="#E6E6E6" />
    <path
      d="M220.5 212c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5ZM274.5 212c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5ZM16 219h36.201M71 219h36.201M204 219h36.201M259.496 219H288.5M126 219h58.553"
      stroke="#E6E6E6"
    />
    <path
      d="M95.802 250.46c2.54 0 4.02-1.8 4.02-3.9 0-2.1-1.46-3.9-4.02-3.9h-5v6.74l-1.2-.02v1.08h1.2v1.66h-1.2v1.08h1.2v2.8h1.14v-2.8h4.62v-1.04l-4.62-.02v-1.68h3.86Zm-3.86-6.76h3.74c1.76 0 2.94 1.18 2.94 2.86s-1.18 2.86-2.94 2.86h-3.74v-5.72Z"
      fill="#E6E6E6"
    />
    <path
      d="M10.021 257.413 25.434 242M20.021 257.413 35.434 242M31.021 257.413 46.434 242M50.022 257.413 65.434 242M60.022 257.413 75.434 242M70.022 257.413 85.434 242M10 272.354h99.925M10 289.354h109.925M10 303.354h143.925"
      stroke="#E6E6E6"
    />
    <path
      d="m14.548 116.507-.232-.122-.233.122-3.007 1.579.574-3.343.045-.259-.188-.184-2.432-2.367 3.36-.488.26-.038.117-.235 1.504-3.043 1.503 3.043.116.235.26.038 3.36.488-2.43 2.367-.19.184.045.259.575 3.343-3.007-1.579ZM28.409 116.507l-.233-.122-.232.122-3.007 1.579.574-3.343.045-.259-.189-.184-2.43-2.367 3.36-.488.26-.038.116-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.36.488-2.43 2.367-.19.184.045.259.574 3.343-3.006-1.579ZM42.27 116.507l-.233-.122-.232.122-3.007 1.579.574-3.343.045-.259-.189-.184-2.431-2.367 3.36-.488.26-.038.117-.235 1.503-3.043 1.504 3.043.116.235.26.038 3.36.488-2.43 2.367-.19.184.045.259.574 3.343-3.006-1.579ZM56.13 116.507l-.232-.122-.233.122-3.006 1.579.574-3.343.045-.259-.189-.184-2.431-2.367 3.36-.488.26-.038.117-.235 1.503-3.043 1.503 3.043.117.235.26.038 3.36.488-2.431 2.367-.189.184.045.259.574 3.343-3.007-1.579ZM69.991 116.507l-.232-.122-.233.122-3.006 1.579.574-3.343.044-.259-.188-.184-2.431-2.367 3.36-.488.26-.038.117-.235 1.503-3.043 1.503 3.043.117.235.26.038 3.36.488-2.431 2.367-.189.184.045.259.574 3.343-3.007-1.579ZM300.044 28c.984-.409 9.956-4.316 9.956-10.873 0-6.938-5.876-6.095-5.876-6.095s-2.859.315-4.124 2.707c-1.265-2.392-4.124-2.707-4.124-2.707S290 10.19 290 17.127c0 6.557 8.972 10.464 9.956 10.873h.088ZM10 142.373 20.373 132M17 142.373 27.373 132M24 142.373 34.373 132M37 142.373 47.373 132M44 142.373 54.373 132M51 142.373 61.373 132M58 142.373 68.373 132M65 142.373 75.373 132M78 142.373 88.373 132M85 142.373 95.373 132M13 157h105.35M280 155c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24ZM265.081 136.457l11.619-11.618M271.567 136.457l11.619-11.618M279.351 136.457l11.619-11.618M285.838 136.457l11.618-11.618"
      stroke="#C2C5CC"
    />
  </svg>
);
const Memo = memo(SvgMobileSkeleton);
export default Memo;
